import { Pipe, PipeTransform } from '@angular/core';

import { format } from 'date-fns';

@Pipe({name: 'momentFormat'})
export class DateFnsFormatPipe implements PipeTransform {
    transform(date: any, formatTo: string): any {
        return format(new Date(date), formatTo);
    }
}
